export default __webpack_public_path__ + "static/media/Tractor.330f46da.jpg";